import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Modalidad } from 'src/app/modal/modalidad/modalidad';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ModalidadService {

  constructor(private httpClient:HttpClient) { }

  obtenerAdminList(){
    let url = `${environment.urlBase}${environment.listModalidad}`;
    //console.log("url",url);
    return this.httpClient.get<Modalidad>(url).pipe(
      map(data => {   
        let response: Modalidad;
        response = data;
        return response;
      },
      error =>{      
        return new Response("9999", error);
      })) 
  }
}
